import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Confirmation } from '../notification/confirmation';

export const ConfirmClearFolderDialog = ({
  visible,
  cancelAction,
  deleteAction
}) => {
  const { t } = useTranslation();

  return (
    <Confirmation
      initialModalState={visible}
      onAccept={deleteAction}
      onCancel={cancelAction}
      message={t('messageList.clearFolderDialog.message')}
      titleAccept={t('messageList.clearFolderDialog.deleteAll')}
      titleCancel={t('general.cancel')}
      confirmType="confirm-info"
      iconType="lf-icon lf-icon-information"
    />
  );

}

ConfirmClearFolderDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  cancelAction: PropTypes.func.isRequired,
  deleteAction: PropTypes.func.isRequired
};

export default ConfirmClearFolderDialog;
